export default "__VITE_ASSET__D5a0k8x$__"